import { Flex,Table } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './loan.module.css' 
import ReportStateTag from '../../cpn/StateTag';
import LoanAddReportEdit from './LoanAddReportEdit';    
import LoanEditReportEdit from './LoanEditReportEdit';
import Copy from '../../cpn/Copy';
import LoanCheck from './LoanCheck';
function LoanListReportEdit(props) {

     // 格式化金额显示
     const formatCurrency = (text) => (
         <span style={{color:'#660099'}}>
             ￥{Number(text).toLocaleString('zh-CN', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
             })}
         </span>
     );
     const [list, setList] = useState([])
    useEffect(() => {
        if(props.jk_data){
            setList([...props.jk_data].sort((a, b) => a.jk_id - b.jk_id))
        }
    }, [props.jk_data])
     // 基础列定义
     const columns = [
        {  
            dataIndex: 'index', 
            width: 42, 
            key: 'index' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },
        { 
            title: '借款人', 
            dataIndex: 'jk_kh_name', 
            width: 200, 
            key: 'jk_kh_name',
            render: (text, record) => {
                if(record.jk_state === '1'){
                    return <LoanEditReportEdit
                                jk_id={record.jk_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                jk_bzd_id={record.jk_bzd_id}
                                jk_price={record.jk_price}
                                jk_content={record.jk_content}
                                jk_date={record.jk_date}
                                jk_bzd_date={props.dsbzd_date}
                                jk_bzd_date_end={props.dsbzd_date_end}
                                jk_bzd_name={props.dsbzd_name}
                                jk_type_id={record.jk_type_id}
                                jk_type_name={record.jk_type_name}
                                jk_kh_id={record.jk_kh_id}
                                jk_kh_name={record.jk_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                jk_num={record.jk_num}
                                jk_amount={record.jk_amount}
                                jk_uid={record.jk_uid}
                                jk_state={record.jk_state}
                                jk_state_time={record.jk_state_time}
                                jk_uname={record.jk_uname}
                                jk_image_name={record.jk_image_name}
                                jk_image_file={record.jk_image_file}
                                jk_name={record.jk_name}
                                jk_bm_id={record.jk_bm_id}
                                jk_bm_name={record.jk_bm_name}
                                jk_khyhzh_id={record.jk_khyhzh_id}
                                jk_khyhzh_name={record.jk_khyhzh_name}
                                jk_ctime={record.jk_ctime}
                            />
                }else{
                    return <LoanCheck
                                type='button'
                                jk_id={record.jk_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                jk_bzd_id={record.jk_bzd_id}
                                jk_price={record.jk_price}
                                jk_content={record.jk_content}
                                jk_date={record.jk_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                jk_type_id={record.jk_type_id}
                                jk_type_name={record.jk_type_name}
                                jk_kh_id={record.jk_kh_id}
                                jk_kh_name={record.jk_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                jk_num={record.jk_num}
                                jk_amount={record.jk_amount}
                                jk_uid={record.jk_uid}
                                jk_state={record.jk_state}
                                jk_image_name={record.jk_image_name}
                                jk_image_file={record.jk_image_file}
                                dsbzd_id={props.dsbzd_id}
                                jk_name={record.jk_name}
                                jk_bm_id={record.jk_bm_id}
                                jk_bm_name={record.jk_bm_name}
                                jk_khyhzh_id={record.jk_khyhzh_id}
                                jk_khyhzh_name={record.jk_khyhzh_name}
                                jk_ctime={record.jk_ctime}
                            />
                }
            }
        },
        { 
             title: '借款金额', 
             dataIndex: 'jk_amount',    
             width: 200, 
             key: 'jk_amount', 
             render: formatCurrency 
         },
        { 
            title: '备注', 
            dataIndex: 'jk_content', 
            key: 'jk_content',
            render: (text) => <Copy title={text}/>
        },    
        {
            title: '状态',
            dataIndex: 'jk_state',
            key: 'jk_state',
            render: (text) => <ReportStateTag state={text} />,
            width: 80,
        },
        {
            title: '编号',
            width: 60, 
            key:'jk_id',
            dataIndex:'jk_id',            
        },
       
     ];

    return (
        <div>
            <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',color:'#660099'}}>借款单</div>                
                {props.report_type === 'edit' ? <LoanAddReportEdit  
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}                                                                           
                    dsbzd_date={props.dsbzd_date}
                    dsbzd_date_end={props.dsbzd_date_end}
                    dsbzd_name={props.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={props.dsbzd_uid}
                    dsbzd_state={props.dsbzd_state}
                    dsbzd_bm_id={props.dsbzd_bm_id}
                    dsbzd_bm_name={props.dsbzd_bm_name}
                    dsbzd_dscp_id={props.dsbzd_dscp_id}
                    dsbzd_dscp_name={props.dsbzd_dscp_name}
                    dsbzd_kh_id={props.dsbzd_kh_id}
                    dsbzd_kh_name={props.dsbzd_kh_name}
                /> : null}                    
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                style={{marginTop:'10px'}}
                size='small'
                rowKey="jk_id"                    
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);    
                    if(total>0){
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} key="summary-1" colSpan={1}></Table.Summary.Cell> 
                                <Table.Summary.Cell index={2} key="summary-2" colSpan={1}>
                                    <span style={{color:'#660099'}}>合计￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} key="summary-3" colSpan={columns.length - 2} ></Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }
                    return null;
                }}
                locale={{
                    emptyText: '暂无借款单' // This will display text when the table is empty
                }}
            />
        </div>
    )
}

export default LoanListReportEdit